/**
 * Created by andrey on 17.07.2025
 */

const Conversions = function () {
    this.initLoggers();

    this.trackPurchase = this.loggersApply.bind(this, "trackPurchase");
    this.trackAdRevenue = this.loggersApply.bind(this, "trackAdRevenue");

    this.trackUserId = this.loggersApply.bind(this, "trackUserId");

    // Google Play's pre-launch robots are not installs
    if (connector.info.isGoogleTestDevice) {
        this.disable();
    }
};

// stops the attribution and analytics loggers for the rest of the install, the metrics logger keeps working (connector.conversions.disable)
Conversions.prototype.disable = function () {
    this.disabled = true;
};

Conversions.prototype.initLoggers = function () {
    const loggers = this.loggers = {};

    loggers.metrics = new ConversionsMetricsLogger();

    AdjustLogger.loadConfig(() => {
        if (AdjustLogger.isApplicable()) {
            loggers.adjust = new AdjustLogger();
        }
    });

    if (InstantLogger.isApplicable()) {
        loggers.instant = new InstantLogger();
    }

    if (SamsungLogger.isApplicable()) {
        loggers.samsung = new SamsungLogger();
    }

    if (GoogleAnalyticsLogger.isApplicable()) {
        loggers.google = new GoogleAnalyticsLogger();
    }

    if (FirebaseLogger.isApplicable()) {
        loggers.firebase = new FirebaseLogger();
    }

    if (YandexLogger.isApplicable()) {
        loggers.yandex = new YandexLogger();
    }

    if (YandexMetrikaLogger.isApplicable()) {
        loggers.yandexMetrika = new YandexMetrikaLogger();
    }

    if (FacebookPixelLogger.isApplicable()) {
        loggers.facebookPixel = new FacebookPixelLogger();
    }

    if (G5Logger.isApplicable()) {
        loggers.g5 = new G5Logger();
    }

    if (ArkadiumLogger.isApplicable()) {
        loggers.arkadium = new ArkadiumLogger();
    }

    if (CrazyLogger.isApplicable()) {
        loggers.crazy = new CrazyLogger();
    }
};

Conversions.prototype.trackEvent = function (name, params = {}) {
    if (typeof params === "number") {
        params = { value: params };
    }

    params = params || {};

    if (!name) {
        console.error("analytics logEvent: empty name");
        return;
    }

    const timespent = connector.metrics.getDaysSinceRegistration() * 24 * 60 * 60 * 1000;

    for (const key in this.loggers) {
        const logger = this.loggers[key];

        if (!logger.trackEvent || params.loggers && !params.loggers.includes(key)) {
            continue;
        }

        if (!logger.metrics && this.disabled) {
            continue;
        }

        const lifetime = params[key] && params[key].lifetime || params.lifetime || logger.config.lifetime;

        if (timespent >= connector.utils.parseInterval(lifetime)) {
            continue;
        }

        logger.trackEvent(name, params);

        if (params.nickname && !logger.metrics) {
            const nicknames = params.nickname.split(",");
            for (const nickname of nicknames) {
                logger.trackEvent(nickname, params);
            }
        }
    }
};

Conversions.prototype.loggersApply = function (method, ...args) {
    if (this.disabled) {
        return;
    }

    for (const key in this.loggers) {
        const logger = this.loggers[key];
        if (logger[method]) {
            logger[method].call(logger, ...args);
        }
    }
};